import React from 'react'
import { DateCell, TimeCell, NumberCell } from 'components/DataTableTest'
import { Checkbox } from 'components/forms'
import numberFormatter from 'helpers/numberFormatter'

export const loyaltyCards = ({ t, locales, showUsersCol }) => ([
	{
		caption: t('common.fields.code'),
		dataField: 'cardId'
	}, {
		caption: t('statistic_section.strings.card_name'),
		dataField: 'cardName'
	}, {
		caption: t('common.fields.date'),
		dataField: 'dateTime',
		calculateDisplayValue: row => DateCell({ locales })({ value: row.dateTime }),
	}, {
		caption: t('common.fields.time'),
		dataField: 'dateTime',
		calculateDisplayValue: row => TimeCell({ locales })({ value: row.dateTime }),
		name: 'time'
	}, {
		caption: t('common.fields.cash_register'),
		dataField: 'cashRegisterName',
		calculateDisplayValue: row => row.cashRegisterId === null ? t('statistic_section.strings.loyalty_card_web_transaction') : row.cashRegisterName
	}, {
		caption: t('statistic_section.strings.bill_number'),
		dataField: 'billNumber'
	}, {
		caption: t('statistic_section.strings.user_name'),
		dataField: 'userName',
		visible: !!showUsersCol
	}, {
		caption: t('common.fields.name'),
		dataField: 'transactionName'
	}, {
		caption: t('statistic_section.strings.group'),
		dataField: 'group'
	}, {
		caption: t('common.fields.type'),
		dataField: 'type',
		calculateDisplayValue: row => {
			switch(row.type) {
				case 'refil': return t('loyalty_card_section.strings.credit')
				case 'purchase': return t('statistic_section.strings.purchase')
				default: return ''
			}
		}
	}, {
		caption: t('common.fields.total_price'),
		dataField: 'total',
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float', precision: 2 }
	}
])

export const bills = ({ t, locales }) => ([
	{
		caption: t('common.fields.quantity'),
		dataField: 'amount',
		cellRender: NumberCell({ locales, floatsPrecisionOnly: true })
	}, {
		caption: t('common.fields.code'),
		dataField: 'product.code'
	}, {
		caption: t('common.fields.name'),
		dataField: 'product.name',
		calculateDisplayValue: (row) => {
			const { product, flag, original } = row
			const cellValue = product?.name
			if(cellValue) {
				return cellValue
			}
			switch(flag) {
				case 'TotalAmount':
					return t('common.fields.total')
				case 'TotalInEuro':
					return `${t('closing_section.strings.billitem_given')} (€ ${numberFormatter(original.mul1, { locale: locales, toFixed: 2 })}) `
				case 'Retour':
					return t('statistic_section.strings.return')
				case 'TotalInCHF':
					return t('statistic_section.strings.given')
				case 'TotalInCardValue':
					return t('statistic_section.strings.card_value')
				default:
					return flag || ''
			}
		}
	}, {
		caption: t('common.strings.price'),
		dataField: 'price',
		cellRender: NumberCell({ locales })
	}, {
		caption: '%',
		dataField: 'discountPercent'
	}, {
		caption: t('statistic_section.strings.in_cafe'),
		dataField: 'inCafe',
		cellRender: ({ value }) => (typeof value === 'boolean' ?
			<div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
				<Checkbox
					noForm
					checked={value}
					disabled
				/>
			</div>
			: null)
	}, {
		caption: t('common.strings.vat'),
		dataField: 'codeMWSt',
		calculateDisplayValue: ({ codeMWSt }) => {
			switch(codeMWSt) {
				case 'free':
					return t('closing_section.fields.vat_free')
				case 'normal':
					return t('closing_section.fields.vat_normal')
				case 'reduced':
					return t('closing_section.fields.vat_reduced')
				case 'special':
					return t('closing_section.fields.vat_special')
				default:
					return codeMWSt || ''
			}
		}
	}, {
		caption: t('common.fields.total_price'),
		dataField: 'total',
		cellRender: NumberCell({ locales })
	}
])
